import Participant from './components/Participant';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'participant',
  pluginComponent: Participant,
});
